import {KTSVG} from '_metronic/helpers'
import inventoryService from 'app/services/ProductsService/InventoryService/InventoryService'
import {FC, useEffect, useState} from 'react'
import LocationListItem from './LocationListItem'
import {ModalBody, ModalHeader} from '_core/components/Modal'
import {Modal} from 'react-bootstrap'
import {Button} from '_core'
import ordersService from 'app/services/OrdersService/OrdersService'
import {useDispatch} from 'react-redux'
import {showMessage} from 'app/redux/messageSlice'
import eventPublishService from 'app/services/EventPublishService/EventPublishService'
import {eventNames} from 'app/constant'

type Props = {
  show: boolean
  onClose: () => void
  fulfillmentLocation?: any
  setFulfillmentLocation?: any
}
const InventoryLocationChange: FC<Props> = ({
  show,
  onClose,
  fulfillmentLocation,
  setFulfillmentLocation,
}) => {
  const dispatch = useDispatch()
  const [locations, setLocations] = useState([])
  const [selectedLocation, setSelectedLocation] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const fetch = async () => {
      setIsFetching(true)
      const {data} = await inventoryService.locationList()
      setLocations(data)
      setIsFetching(false)
    }
    fetch()
  }, [])

  const getCurrentLocation = async () => {
    const {locationId} = await ordersService.getFulfillmentCurrentLocation({
      id: fulfillmentLocation.fulfillmentId,
    })
    setFulfillmentLocation({...fulfillmentLocation, currentLocation: locationId})
  }

  const handleSetSelectedLocation = (id: any) => {
    if (fulfillmentLocation.currentLocation !== id) {
      setSelectedLocation(id)
    }
  }

  const handleSave = async () => {
    try {
      setIsSubmitting(true)
      const result = await ordersService.updateFulfillmentLocation({
        locationId: selectedLocation,
        id: fulfillmentLocation.fulfillmentId,
      })
      if (result.id) {
        getCurrentLocation()
      }
      await eventPublishService.publish({
        message: {
          id: result.id,
          previousLocationID: fulfillmentLocation.currentLocation,
          currentLocationID: selectedLocation,
        },
        name: eventNames.fulfilledLocationChange,
      })
      dispatch(showMessage({text: 'Location updated successfully', variant: 'success'}))
    } catch (error) {
      dispatch(showMessage({text: 'Error occured while updating location', variant: 'error'}))
    } finally {
      setIsSubmitting(false)
    }
  }
  return (
    <>
      <Modal show={show} onHide={onClose} centered>
        <ModalHeader
          title={
            <>
              <KTSVG
                className='svg-icon-2 px-2 py-2 border border-3 rounded-1 border-muted svg-icon-primary me-4'
                path='/media/icons/corksy/location.svg'
              />
              Change Location
            </>
          }
          toolbar={{onClick: onClose}}
        />
        <ModalBody isFetching={isFetching}>
          {locations.map((location: any) => {
            return (
              <LocationListItem
                location={location}
                handleSelect={handleSetSelectedLocation}
                selectedLocation={selectedLocation}
                currentLocationId={fulfillmentLocation.currentLocation}
              />
            )
          })}
        </ModalBody>
        <div className='seperator mb-5 d-flex mx-6'>
          <button id='btnClose' className='btn explore-btn-outline btn-sm w-100' onClick={onClose}>
            Cancel
          </button>
          <Button
            onClick={handleSave}
            isSubmitting={isSubmitting}
            id='btnChangeLocation'
            type='button'
            className='btn btn-primary-active btn-sm ms-5 w-100'
            title='Change Location'
            disabled={!selectedLocation}
          />
        </div>
      </Modal>
    </>
  )
}
export default InventoryLocationChange
